import type { Contato } from '@plane/shared';

/**
 * Derivações do contato.
 *
 * O conteúdo em si vem do painel — ver `hooks/use-contato.ts`. Aqui ficam só as
 * formas derivadas dele, para que nenhuma tela monte `tel:` ou `wa.me` na mão e
 * erre o formato.
 */

/** `tel:` quer o número com `+` e só dígitos. */
export function hrefDoTelefone(contato: Contato): string {
  return `tel:+${contato.telefoneDigitos}`;
}

export function hrefDoEmail(contato: Contato): string {
  return `mailto:${contato.email}`;
}

/** Saudação que o protótipo já preenchia nos links de WhatsApp. */
export function saudacaoDeWhatsApp(contato: Contato): string {
  return `Olá! Vim pelo site da ${contato.empresa} e gostaria de um orçamento.`;
}

/**
 * Link do WhatsApp com a mensagem já escrita.
 *
 * Usa `whatsappDigitos`, e não o telefone: são números diferentes, e apontar o
 * `wa.me` para a linha fixa abre uma conversa que não chega em ninguém.
 */
export function linkDeWhatsApp(contato: Contato, mensagem: string): string {
  return `https://wa.me/${contato.whatsappDigitos}?text=${encodeURIComponent(mensagem)}`;
}
